<div class="card-body d-flex flex-column gap-4">
    <div class="content-row" *ngFor="let collateral of collaterals">               
        <div class="row mb-4 pb-3 mb-lg-0 pb-lg-0">
            <div class="col-lg-12">
                <dynamic-field [props]="props?.Name" [canBeEmpty]="true">
                    <div HJSuppress class="d-flex justify-content-center justify-content-lg-start">
                        <span class="fs-5 fw-bold">{{collateral?.name}}</span>
                    </div>
                </dynamic-field>
                <dynamic-field [props]="props?.Type" [canBeEmpty]="true">
                    <div class="d-flex justify-content-center justify-content-lg-start align-items-center mb-2">
                        <span class="title-label fw-semibold">{{'contractDetail.collaterals.type' | translate}}:</span>
                        <span HJSuppress class="fw-bold ms-2">{{collateral?.type}}</span>
                    </div>
                </dynamic-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-3">
                <dynamic-field [props]="props?.Valability" [canBeEmpty]="true">
                    <div class="d-flex justify-content-center justify-content-lg-start align-items-center value-col" *ngIf="collateral?.valability">
                        <span class="title-label fw-semibold"> {{'contractDetail.collaterals.valability' | translate}}</span> 
                        <span HJSuppress class="l-value ms-2">
                            {{collateral?.valability | localizedDate}}
                        </span>
                    </div>
                </dynamic-field>
            </div>
            <div class="col-lg-4">
                <dynamic-field [props]="props?.Guarantor" [canBeEmpty]="true">
                    <div class="d-flex flex-lg-column justify-content-between value-col">    
                        <div class="title-label fw-semibold">
                            {{'contractDetail.collaterals.guarantor' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            {{collateral?.guarantor}}
                        </div>
                    </div>
                </dynamic-field>
            </div>
            <div class="col-lg-3">
                <dynamic-field [props]="props?.Value" [canBeEmpty]="true">
                    <div class="d-flex flex-lg-column justify-content-between value-col">
                        <div class="title-label fw-semibold">
                            {{'contractDetail.collaterals.value' | translate}}
                        </div>
                        <div HJSuppress class="l-value">
                            <span *ngIf="collateral?.value">
                                {{ collateral?.value | number:'1.' }} 
                                {{collateral?.currency}} 
                            </span>
                        </div>
                    </div>
                </dynamic-field>
            </div>
            <div class="col-lg-2">
                <dynamic-field [props]="props?.Percentage" [canBeEmpty]="true">
                    <div class="d-flex flex-lg-column justify-content-between percentage-col">
                        <div class="title-label fw-semibold">
                            {{'contractDetail.collaterals.percent' | translate}}
                        </div>
                        <div HJSuppress class="l-value l-perc-value">
                            {{ collateral?.percentage | replaceIfNull }}%
                        </div>
                    </div>       
                </dynamic-field>
            </div>
        </div>
    </div>
</div>
